<div class="d-flex flex-row flex-wrap page-wrapper">
  @for (child of tree; track child.id) {
    @switch (child.type) {
      @case (ContentType.PAGE) {
        <div class="card-wrapper">
          <div class="card">
            <div class="card-body d-flex flex-column justify-content-between">
              <div>
                <h3 class="card-title">
                  <span>{{ child.name }}</span>
                </h3>
                @if (child.content) {
                  <p>{{ child.content }}</p>
                }
              </div>
              <div>
                <a [routerLink]="['/information', child.id]" class="btn btn-primary">{{ 'contents.view' | translate }}</a>
              </div>
            </div>
          </div>
        </div>
      }
      @case (ContentType.FOLDER) {
        <div class="card-wrapper">
          <div class="card">
            <div class="card-body d-flex flex-column justify-content-between">
              <div>
                <h3 class="card-title">
                  <span>{{ child.name }}</span>
                </h3>
                @if (child.content) {
                  <p>{{ child.content }}</p>
                }
                <p class="text-muted mb-0">
                  @if (!child.children || child.children!.length === 0) {
                    {{ 'contents.noItem' | translate }}
                  } @else if (child.children!.length === 1) {
                    {{ 'contents.singleItem' | translate }}
                  } @else {
                    {{ 'contents.itemCount' | translate: { count: child.children!.length } }}
                  }
                </p>
              </div>
              <div>
                <a [routerLink]="['/information', child.id]" class="btn btn-primary">{{ 'contents.view' | translate }}</a>
              </div>
            </div>
          </div>
        </div>
      }
    }
  }
</div>
